import React from 'react';
import './App.css';
import { RouterProvider } from 'react-router-dom';
import router from './router/router';
import './style/themes.scss';
import useTheme from './hooks/useTheme';
import { Provider } from 'react-redux';
import store, { persistor } from './redux/store';
import { PersistGate } from 'redux-persist/integration/react';
import { ErrorsProvider } from './hooks/useError/useError';

function App() {
  useTheme();

  return (
    <Provider store={store}>
      <PersistGate persistor={persistor}>
        <ErrorsProvider>
          <RouterProvider router={router} />
        </ErrorsProvider>
      </PersistGate>
    </Provider>
  );
}

export default App;
